import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { Guid } from 'guid-typescript';
import { Observable } from 'rxjs';
import { CommonService } from '../../Services/common/common.service';

@Injectable({
  providedIn: 'root',
})
export class ReportSettingsService {
  constructor(private http: HttpClient, private commonService: CommonService) {}

  saveCompanyContacts(contact: any[]): Observable<any> {
    const headers = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http.post<any>(`${environment.apiVersionUrl}Contacts/saveCompanyContacts`, this.commonService.trimObjectSpace(JSON.stringify(contact)), headers);
  }

  getAllContactsBasedonType(contactType: any): Observable<any> {
    return this.http.get<any>(`${environment.apiVersionUrl}Contacts/getAllContactsBasedonType?contacttype=${contactType}`);
  }

  getAllContactsBasedonId(contactId: Guid): Observable<any> {
    return this.http.get<any>(`${environment.apiVersionUrl}Contacts/getContactsBasedonId?contactId=${contactId}`);
  }

  deleteContact(contactId: Guid): Observable<any> {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: JSON.stringify(contactId),
    };
    
    return this.http.delete<any>(`${environment.apiVersionUrl}Contacts/deletecontact`, options);
  }

  getTrusteesDataById(type: any): Observable<any> {
    return this.http.get<any>(`${environment.apiVersionUrl}Audit/getTrusteesDataById?type=${type}`);
  }

  getTrusteesDataByPeriodId(type: any, periodId: any): Observable<any> {
    return this.http.get<any>(`${environment.apiVersionUrl}Audit/getTrusteesDataByPeriodId?type=${type}&accountingPeriodId=${periodId}`);
  }

  saveTrusteeDisclosures(report: any): Observable<any> {
    const headers = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http.post<any>(`${environment.apiVersionUrl}Audit/saveTrusteeDisClosures`, this.commonService.trimObjectSpace(JSON.stringify(report)), headers);
  }

  getBalancesheetDataById(type: any): Observable<any> {
    return this.http.get<any>(`${environment.apiVersionUrl}Audit/getBalancesheetDataById?type=${type}`);
  }

  saveBalancesheetDisclosures(report: any): Observable<any> {
    const headers = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http.post<any>(`${environment.apiVersionUrl}Audit/saveBalancesheetDisclosures`, this.commonService.trimObjectSpace(JSON.stringify(report)), headers);
  }

  getAllIndependentExaminers(): Observable<any> {
    return this.http.get<any>(`${environment.apiVersionUrl}Contacts/getAllIndependentExaminers`);
  }

  getExaminersBasedonId(examinerId: any): Observable<any> {
    return this.http.get<any>(`${environment.apiVersionUrl}Contacts/getExaminersBasedonId?examinerId=${examinerId}`);
  }

  saveIndependentExaminers(examinerDetails: any): Observable<any> {
    const headers = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http.post<any>(`${environment.apiVersionUrl}Contacts/saveIndependentExaminers`, this.commonService.trimObjectSpace(JSON.stringify(examinerDetails)), headers);
  }

  deleteExaminer(examinerId: Guid): Observable<any> {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: JSON.stringify(examinerId),
    };
    
    return this.http.delete<any>(`${environment.apiVersionUrl}Contacts/deleteexaminer`, options);
  }
}